import { ItemsReducerState } from '../../../application/store/reducers/items/itemsReducer';
import { getItemsList, getItemsStore } from '../../../application/store/reducers/items/itemsSelectors';
import { ItemValidator } from '../../ItemValidator';
import { ensureIsItem, isResourcesFolder, Item, ItemHelper, MainItem } from '@ael/core-api';
import { createSelector } from 'reselect';

export const isValidSelector = createSelector(
  getItemsList,
  (items) => (item: Item) => ItemValidator.isValid(item, items)
);
export const getValidMainItemsSelector = createSelector(
  getItemsStore,
  isValidSelector,
  (state: ItemsReducerState, isValid): MainItem[] => {
    return state
      .filter((item: Item) => !ItemHelper.isContentItem(item) && isValid(item) && !isResourcesFolder(item))
      .map((item: Item) => {
        ensureIsItem(item);
        return item;
      })
      .toIndexedSeq()
      .toArray();
  }
);
export const getFirstValidMainItemSelector = createSelector(
  getValidMainItemsSelector,
  (mainItems): MainItem => mainItems[0]
);
